import * as monaco from 'monaco-editor/esm/vs/editor/editor.api';
import colors from "shared/styles/colors";

const registerMonacoBaseThemes = () => {
    monaco.editor.defineTheme("frends-dark", {
        base: "vs-dark",
        inherit: true,
        rules: [],
        colors: {
            "editor.background": colors.dark2
        }
    })
    monaco.editor.defineTheme("frends-light", {
        base: "vs",
        inherit: true,
        rules: [],
        colors: {
            "editor.background": colors.white
        }
    })
}

export default registerMonacoBaseThemes;